import {
    createSelector
} from 'reselect'

export const alertEntriesSelector = createSelector(state => state && state.alerts && state.alerts.alertEntries, alertEntriesSelector => alertEntriesSelector);